module.exports = require("@cybs-plugins/theme");